function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, String, columns, filterSearchPlaceholder, selectedTab, tabs) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const filterSearchText = $helpers.getFilterSearchText();;
    return {
      value: (h("div", {
        "class": {
          'filter-bar-table': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'filter-bar-table-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filter-bar-table-tabs': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
              "attrs": {
                testref: $helpers.getTabsTestRef(),
                size: `large`,
                selected: selectedTab,
                theme: `lite`,
                'style-override': `.mp-toggle-option { margin-left: 15px; }`,
              },
              "on": {
                select: $helpers.onTabChange,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (tabs);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, tab, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const {
                        value,
                        label
                      } = tab;;
                      __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                        "attrs": {
                          value: value || tab
                        },
                      }, [__vjadeSafeCode(label || value || tab)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var tab = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          const {
                            value,
                            label
                          } = tab;;
                          __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                            "attrs": {
                              value: value || tab
                            },
                          }, [__vjadeSafeCode(label || value || tab)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `actions`
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filter-bar-table-select': true
            },
          }, (function() {
            var __jade_nodes = [];
            const config = $helpers.getTableHeaderSelectConfig();
            __jade_nodes = __jade_nodes.concat((config) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": $helpers.serializeAttributes(config),
                "on": {
                  change: ev => $helpers.handleTableHeaderSelectChange(ev)
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    theme: `tertiary`,
                    icon: `export`,
                    slot: `trigger`
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("" + (config.buttonText) + "");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((config.disabled) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    placement: `left`
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("" + (config.tooltipText) + "");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((!($attr('hide-filter-bar'))) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-filter-bar", {
            "attrs": {
              testref: $helpers.getFilterBarTestRef(),
              'actions': JSON.stringify($helpers.getActionOptions()),
              'filters': JSON.stringify($helpers.getFilterSelectOptions()),
              'result-count': $helpers.getResultsLabel(),
              'selected-count': $helpers.getSelectedCount(),
              'search-placeholder': filterSearchPlaceholder,
              'search-text': $helpers.getFilterSearchText(),
            },
            "on": {
              updateInput: $helpers.onFilterSearchChange,
              clickAction: $helpers.onClickAction,
              clearSelected: $helpers.onClearSelected,
              changeFilter: $helpers.onFilterSelectChange,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-table", {
          "attrs": $helpers.getTableAttrs(),
          "props": {
            rows: $helpers.getTableRows(),
            columns,
          },
          "on": {
            selectionChange: $helpers.onSelectionChange,
            numResultsChange: $helpers.onTableResultsChange,
            rowClick: $helpers.onRowClick,
            cellClick: $helpers.onCellClick,
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "columns" in locals ? locals.columns : typeof columns !== "undefined" ? columns : undefined, "filterSearchPlaceholder" in locals ? locals.filterSearchPlaceholder : typeof filterSearchPlaceholder !== "undefined" ? filterSearchPlaceholder : undefined, "selectedTab" in locals ? locals.selectedTab : typeof selectedTab !== "undefined" ? selectedTab : undefined, "tabs" in locals ? locals.tabs : typeof tabs !== "undefined" ? tabs : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;